export const dictionary = {
  hiragana: {
    a_groupH: {
      characters: {
        あ: ['a'],
        い: ['i'],
        う: ['u'],
        え: ['e'],
        お: ['o'],
      },
    },
    ka_groupH: {
      characters: {
        か: ['ka'],
        き: ['ki'],
        く: ['ku'],
        け: ['ke'],
        こ: ['ko'],
      },
    },
    sa_groupH: {
      characters: {
        さ: ['sa'],
        し: ['shi'],
        す: ['su'],
        せ: ['se'],
        そ: ['so'],
      },
    },
    ta_groupH: {
      characters: {
        た: ['ta'],
        ち: ['chi'],
        つ: ['tsu'],
        て: ['te'],
        と: ['to'],
      },
    },
    na_groupH: {
      characters: {
        な: ['na'],
        に: ['ni'],
        ぬ: ['nu'],
        ね: ['ne'],
        の: ['no'],
      },
    },
    ha_groupH: {
      characters: {
        は: ['ha'],
        ひ: ['hi'],
        ふ: ['fu'],
        へ: ['he'],
        ほ: ['ho'],
      },
    },
    ma_groupH: {
      characters: {
        ま: ['ma'],
        み: ['mi'],
        む: ['mu'],
        め: ['me'],
        も: ['mo'],
      },
    },
    ya_groupH: {
      characters: {
        や: ['ya'],
        ゆ: ['yu'],
        よ: ['yo'],
      },
    },
    ra_groupH: {
      characters: {
        ら: ['ra'],
        り: ['ri'],
        る: ['ru'],
        れ: ['re'],
        ろ: ['ro'],
      },
    },
    wa_groupH: {
      characters: {
        わ: ['wa'],
        を: ['wo', 'o'],
        ん: ['n'],
      },
    },
    ga_groupH: {
      characters: {
        が: ['ga'],
        ぎ: ['gi'],
        ぐ: ['gu'],
        げ: ['ge'],
        ご: ['go'],
      },
    },
    za_groupH: {
      characters: {
        ざ: ['za'],
        じ: ['ji', 'zi'],
        ず: ['zu', 'du'],
        ぜ: ['ze'],
        ぞ: ['zo'],
      },
    },
    da_groupH: {
      characters: {
        だ: ['da'],
        ぢ: ['di'],
        づ: ['du'],
        で: ['de'],
        ど: ['do'],
      },
    },
    ba_groupH: {
      characters: {
        ば: ['ba'],
        び: ['bi'],
        ぶ: ['bu'],
        べ: ['be'],
        ぼ: ['bo'],
      },
    },
    pa_groupH: {
      characters: {
        ぱ: ['pa'],
        ぴ: ['pi'],
        ぷ: ['pu'],
        ぺ: ['pe'],
        ぽ: ['po'],
      },
    },
    kya_groupH: {
      characters: {
        きゃ: ['kya'],
        きゅ: ['kyu'],
        きょ: ['kyo'],
      },
    },
    sha_groupH: {
      characters: {
        しゃ: ['sha', 'sya'],
        しゅ: ['shu', 'syu'],
        しょ: ['sho', 'syo'],
      },
    },
    cha_groupH: {
      characters: {
        ちゃ: ['cha', 'cya', 'tya'],
        ちゅ: ['chu', 'cyu'],
        ちょ: ['cho', 'cyo'],
      },
    },
    nya_groupH: {
      characters: {
        にゃ: ['nya'],
        にゅ: ['nyu'],
        にょ: ['nyo'],
      },
    },
    hya_groupH: {
      characters: {
        ひゃ: ['hya'],
        ひゅ: ['hyu'],
        ひょ: ['hyo'],
      },
    },
    mya_groupH: {
      characters: {
        みゃ: ['mya'],
        みゅ: ['myu'],
        みょ: ['myo'],
      },
    },
    rya_groupH: {
      characters: {
        りゃ: ['rya'],
        りゅ: ['ryu'],
        りょ: ['ryo'],
      },
    },
  },
  katakana: {
    a_groupK: {
      characters: {
        ア: ['a'],
        イ: ['i'],
        ウ: ['u'],
        エ: ['e'],
        オ: ['o'],
      },
    },
    ka_groupK: {
      characters: {
        カ: ['ka'],
        キ: ['ki'],
        ク: ['ku'],
        ケ: ['ke'],
        コ: ['ko'],
      },
    },
    sa_groupK: {
      characters: {
        サ: ['sa'],
        シ: ['shi', 'si'],
        ス: ['su'],
        セ: ['se'],
        ソ: ['so'],
      },
    },
    ta_groupK: {
      characters: {
        タ: ['ta'],
        チ: ['chi', 'ti'],
        ツ: ['tsu', 'tu'],
        テ: ['te'],
        ト: ['to'],
      },
    },
    na_groupK: {
      characters: {
        ナ: ['na'],
        ニ: ['ni'],
        ヌ: ['nu'],
        ネ: ['ne'],
        ノ: ['no'],
      },
    },
    ha_groupK: {
      characters: {
        ハ: ['ha'],
        ヒ: ['hi'],
        フ: ['fu', 'hu'],
        ヘ: ['he'],
        ホ: ['ho'],
      },
    },
    ma_groupK: {
      characters: {
        マ: ['ma'],
        ミ: ['mi'],
        ム: ['mu'],
        メ: ['me'],
        モ: ['mo'],
      },
    },
    ya_groupK: {
      characters: {
        ヤ: ['ya'],
        ユ: ['yu'],
        ヨ: ['yo'],
      },
    },
    ra_groupK: {
      characters: {
        ラ: ['ra'],
        リ: ['ri'],
        ル: ['ru'],
        レ: ['re'],
        ロ: ['ro'],
      },
    },
    wa_groupK: {
      characters: {
        ワ: ['wa'],
        ヲ: ['wo'],
        ン: ['n'],
      },
    },
    ga_groupK: {
      characters: {
        ガ: ['ga'],
        ギ: ['gi'],
        グ: ['gu'],
        ゲ: ['ge'],
        ゴ: ['go'],
      },
    },
    za_groupK: {
      characters: {
        ザ: ['za'],
        ジ: ['ji', 'zi'],
        ズ: ['zu', 'du'],
        ゼ: ['ze'],
        ゾ: ['zo'],
      },
    },
    da_groupK: {
      characters: {
        ダ: ['da'],
        ヂ: ['di'],
        ヅ: ['du'],
        デ: ['de'],
        ド: ['do'],
      },
    },
    ba_groupK: {
      characters: {
        バ: ['ba'],
        ビ: ['bi'],
        ブ: ['bu'],
        ベ: ['be'],
        ボ: ['bo'],
      },
    },
    pa_groupK: {
      characters: {
        パ: ['pa'],
        ピ: ['pi'],
        プ: ['pu'],
        ペ: ['pe'],
        ポ: ['po'],
      },
    },

    kya_groupK: {
      characters: {
        キャ: ['kya'],
        キュ: ['kyu'],
        キョ: ['kyo'],
      },
    },

    sha_groupK: {
      characters: {
        シャ: ['sha', 'sya'],
        シュ: ['shu', 'syu'],
        ショ: ['sho', 'syo'],
      },
    },

    cha_groupK: {
      characters: {
        チャ: ['cha', 'cya', 'tya'],
        チュ: ['chu', 'cyu'],
        チョ: ['cho', 'cyo'],
      },
    },
    nya_groupK: {
      characters: {
        ニャ: ['nya'],
        ニュ: ['nyu'],
        ニョ: ['nyo'],
      },
    },
    hya_groupK: {
      characters: {
        ヒャ: ['hya'],
        ヒュ: ['hyu'],
        ヒョ: ['hyo'],
      },
    },

    mya_groupK: {
      characters: {
        ミャ: ['mya'],
        ミュ: ['myu'],
        ミョ: ['myo'],
      },
    },
    rya_groupK: {
      characters: {
        リャ: ['rya'],
        リュ: ['ryu'],
        リョ: ['ryo'],
      },
    },
  },
};

//combined dakuten and combination kana, still on the fence if I should include it

//     gya_group: {
//       characters: {
//       ぎゃ: ['gya'],
//       ぎゅ: ['gyu'],
//       ぎょ: ['gyo'],
//       }

//     },
//     ja_group: {
//       characters: {
// じゃ: ['ja', 'jya'],
//       じゅ: ['ju', 'jyu'],
//       じょ: ['jo', 'jyo'],
//       }

//     },
//     bya_group: {
//       characters: {
//  びゃ: ['bya'],
//       びゅ: ['byu'],
//       びょ: ['byo'],
//       }

//     },
//     pya_group: {
//       characters: {
// ぴゃ: ['pya'],
//       ぴゅ: ['pyu'],
//       ぴょ: ['pyo'],
//       }

//     },

// gya_group: {
//     characters: {
//       ギャ: ['gya'],
//       ギュ: ['gyu'],
//       ギョ: ['gyo'],
//     }

//     },
// ja_group: {
//     characters: {
//   ジャ: ['ja', 'jya'],
//   ジュ: ['ju', 'jyu'],
//   ジョ: ['jo', 'jyo
//     }
// '],
// },
// bya_group: {
//     characters: {
//   ビャ: ['bya'],
//   ビュ: ['byu'],
//   ビョ: ['byo'],
//     }

// },
// pya_group: {
//     characters: {
//        ピャ: ['pya'],
//   ピュ: ['pyu'],
//   ピョ: ['pyo'],
//     }

// },
